import { cn } from '@/lib/utils';

interface StepperProps {
  steps: { label: string }[];
  activeStep: number;
}

export const Stepper = ({ steps, activeStep }: StepperProps) => {
  return (
    <div className="flex items-center justify-between gap-10 relative mx-auto">
      <span className="absolute z-0 top-1/2 left-0 w-full h-[2px] bg-[#a1aebe] -translate-y-1/2" />
      {steps?.map((step, index) => (
        <Step key={step.label} index={index} step={step.label} isActive={activeStep >= index} />
      ))}
    </div>
  );
};

const Step = ({ index, step, isActive }: { index: number; step: string; isActive: boolean }) => {
  return (
    <span
      data-step={`${index + 1}.`}
      className={cn(
        `relative flex items-center justify-center px-6 py-2 rounded-full font-semibold text-medium bg-lightPoppy-100 text-jacarta-100 [&:before]:mr-1 [&:before]:content-[attr(data-step)]`,
        { 'bg-lightPoppy-800 text-buttonPurple': isActive }
      )}
    >
      {step}
    </span>
  );
};
